import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryDetailedScreenContextualization({contextualization}) {
    // Used in

    // BUILD
    if (isNullOrUndefined(contextualization))
        return null
    return (
        <div className={"w-full flex flex-col justify-start items-start"}>
            <span className={"text-greyLight11"}>
                {'Pour t’aider à bien saisir le sens de ce mot en mathématiques, voici un exemple tiré d’une situation de la vie courante :'}
            </span>
            <div className={"w-full flex flex-col justify-start items-start px-[12px] pt-[8px] pb-[12px] border-primaryLight3 border-[1px] rounded-[12px] mt-[16px]"}>
                <span className={"whitespace-pre-line text-greyLight11 text-[16px] font-medium sm:font-semibold mt-[2px]"}>
                    {contextualization}
                </span>
            </div>
        </div>
    );
}